export default {
  common: {
    lang: '中文',
    showcase: '社区',
    training: '训练',
    generate: '生成',
    textGenerate: '文本生成',
    imgGenerate: '图像生成',
    videoGenerate: '视频生成',
    modelGenerate: '模型生成',
    settings: '设置',
    logout: '退出登陆'
  },
  notify: {
    notify: '提示',
    inputUsername: '请输入用户名',
    inputPassword: '请输入密码',
    pwdCheckFailed: '密码不一致',
    SignSuccess: '注册成功',
    usernameNullError: '用户名不能为空',
    usernameExistsError: '用户名已占用',
    inputPasswordAgain: '请再次输入密码',
    twicePwdCheckFailed: '两次输入密码不一致',
    emailNullFailed: '邮箱不能为空',
    emailError: '请输入正确的邮箱',
    inputName: '请输入姓名',
    inputCity: '请输入城市',
    inputOrganization: '请输入单位或学校',
    inputJob: '请输入职业',
    inputEmail: '请输入邮箱',
    inputPhone: '请输入号码',
    activeNotify: '此账号待激活是否发送激活邮件?，注意邮件一分钟只能发送一次。',
    sendSuccess: '发送成功',
    activeSubmitSuccess: '提交成功，请在收到邮件后激活您的账号。',
    dataSubmitted: '数据已提交',
    imageOnly: '仅支持png/jpg图片'
  },
  user: {
    signTitle: '用户注册',
    returnPwdTitle: '找回密码',
    loginTitle: 'Log In',
    username: '用户名',
    password: '密码',
    forgetPassword: '忘记密码？',
    sign: '注 册',
    login: '登 陆',
    confirmPassword: '确认密码',
    name: '姓名',
    city: '城市',
    organization: '单位',
    job: '职业',
    email: '邮箱',
    phone: '电话',
    newPassword: '新密码',
    signEmail: '注册邮箱',
    fuGeneratorLabelP1: 'FUGenerator',
    fuGeneratorLabelP2: '启发式AI生成平台',
    fuGeneratorLabelP3: '开启设计之旅',
    fuGeneratorLabelP4: '更多信息',
  },
  generate: {
    hi: 'Hi ',
    headP: '生成建筑设计!',
    previousStep: '上一步',
    clearPanel: '清除面板',
    input: '条件输入',
    generation: '生成算法',
    output: '设计成果',
    semanticInput: '语义输入',
    englishPrompts: '英文描述',
    selectSemanticOrInput: '选择或输入描述',
    guidedInput: '控制输入',
    upload: '上传',
    preProcess: '预处理',
    imageInput: '图片输入',
    imageInformation: '图片信息',
    semanticGeneration: '文本 → 图像',  // 语义生成
    semantic: '文本强度',
    guided: '控制强度',
    models: '模型',
    width: '图片宽度',
    height: '图片高度',
    seed: '图片编号',
    imageGeneration: '图像 → 图像',  // 图片输入
    image: '图像强度',
    rendergraphGen: "线稿 → 渲染图",  // 线稿 → 渲染图
    Img2RenderGen: "参考图 → 渲染图",  // 参考图 → 渲染图
    imageDescriptionGen: '图像 → 文本',  // 描述生成
    imageDescription: '图片描述',  // 图片描述
    generateBtn: '点击生成',
    sendBtn: '数据发送中...',
    imageUpscalar: '低清 → 高清',  // 高清大图
    inpaint: '局部重绘',
    resolution: '清晰度',
    descriptionOutput: '文本输出',  // 文本输出
    SendToSemanticInput: '语义发送下一步',
    imageOutput: '图像输出',
    sendToImageInput: '图像发送下一步',
    SendToGuidedInput: '控制发送下一步',
    origin: '原始',
    originV2: '原始v2',
    birdsEye: '鸟瞰',
    business: '商业',
    indoor: '室内',
    model: '模型',
    highRise: '超高层',
    none: '无',
    architecture: '建筑',
    real: '真实',
    render: '渲染',
    cartoon: '动漫',
    imagePrefix: '图片',
    image1: '图片 1',
    image2: '图片 2',
    image3: '图片 3',
    textDesc: '文本描述',
    imgDesc: '图片描述',
    dragToArea: '拖拽文件至区域',
    uploadDire: '直接上传',
    baseModel: '基础模型',
    extraModel: '附加模型',
    numFrames: '视频秒数',
    downloadToLocal: '下载至本地',
    videoWH: '视频宽高',
    share: '分享至社区',
    bgClear: '背景清除',
    uploadHandle: '上传处理',
    semanticDialog: {
      space: '空间',
      composition: '组合',
      description: '描述',
      Main: '主体',
      Space: '空间',
      Form: '形式',
      Programme: '功能',
      Elements: '构件',
      Properties: '属性',
      Layout: '布局',
      Ratio: '韵律',
      Composition: '组合',
      Stream: '流线',
      Style: '风格',
      Perspective: '视角',
      Atmosphere: '氛围',
      Architect: '建筑师',
      Stylist: '风格主义',
    },
    modelsDialog: {
      baseModel: '基础模型',
      vaeModel: 'VAE模型',
      loraModel: 'LORA模型',
      controlPreprocessorModel: '预处理模型',
    }
  },
  training: {
    headP: 'Customize Your Own Model!'
  },
  showcase: {
    sortByTime: '时间排序',
    sortByHot: '热门排序',
    textGen: '语义生成',
    noMore: '没有更多了～',
    viewMore: '更多内容',
    shareInfoDialog: {
      noImgInput: '无图片输入',
      algorithm: "生成算法",
      Seed: "种子数",
      Width: '图片宽度',
      Height: '图片高度',
      Models: "模型",
      CFGScale: '文本强度',
      ImgInput: '图片输入',
      ControlImg: '控制输入',
      PoPrompts: "描述文本",
      LoraAlpha: '模型权重',
      NoiseLevel: '清晰度',
      ControlScale: '控制强度',
      ImgStrengths: '图像强度',
      algorithms : {
        txtGenerate: '语义生成',
        imgGenerate: '图片输入',
        Img2Prompts: '描述生成',
        Superresolution: '高清大图',
        Inpaint: '局部修改'
      },
      models: {
        '商业': '商业',
        '原始': '原始',
        '鸟瞰': '鸟瞰',
        '室内': '室内',
        '超高层': '超高层',
        '模型': '模型'
      }
    }
  },
  textInput: {
    inputZhOrEn: '输入中文或英文描述',
    transContent: '翻译内容',
    poPromptsContent: '语义的输入',
    inputUsername: '请输入用户名',
    inputNewPwd: '请输入新密码',
    inputPwdAgain: '再次输入密码',
    inputSingEmail: '请输入注册时的邮箱'
  },
  btn: {
    trans: '翻译',
    add: '添加',
    ok: '完成',
    reset: '重置',
    submit: '提交',
    confirm: '确定',
    cancel: '取消',
    download: '下载',
    select: '选择'
  }
}

